import { MutableRange2j0kfnqv5bc35 as MutableRange } from './internals/MutableRange.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HttpHeadersMapp7szignu4ex as HttpHeadersMap } from './HttpHeadersMap.mjs';
import { readLineStrictTo1xxmy01uq4bp as readLineStrictTo } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannelOperations.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  captureStack1fzi4aczwc4hg as captureStack,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx,
  Char19o2r8palgjof as Char,
  Char__compareTo_impl_ypi4mb28h1l6umahrlb as Char__compareTo_impl_ypi4mb,
  Char__toInt_impl_vasixdnyockrdnmht5 as Char__toInt_impl_vasixd,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { skipSpacesAndHorizontalTabs2u6kkzguaojc4 as skipSpacesAndHorizontalTabs } from './internals/Tokenizer.mjs';
import {
  endsWith1a79dp5rc3sfv as endsWith,
  contains2el4s70rdq4ld as contains,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  charSequenceSubSequence1iwpdba8s3jc7 as charSequenceSubSequence,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import {
  Companion_getInstanceu6i25dezdn6m as Companion_getInstance,
  LineEndingMode__plus_impl_ttpz2jpqrbpe81vmkf as LineEndingMode__plus_impl_ttpz2j,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/LineEndingMode.mjs';
import { Companion_instance5d31txb2b6xr as Companion_instance } from './internals/AsciiCharTree.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_hostForbiddenSymbols() {
  _init_properties_HttpParser_kt__gbdom1();
  return hostForbiddenSymbols;
}
var hostForbiddenSymbols;
var httpLineEndings;
var versions;
function *parseHeaders(input, builder, range, $completion) {
  range = range === VOID ? new (MutableRange())(0, 0) : range;
  var headers = new (HttpHeadersMap())(builder);
  try {
    $l$loop: while (true) {
      if ((yield* readLineStrictTo(input, builder, 8192n, VOID, $completion)) === -1n) {
        headers.e2m();
        return null;
      }
      range.g59_1 = builder.s58_1;
      var rangeLength = range.g59_1 - range.f59_1 | 0;
      if (rangeLength === 0)
        break $l$loop;
      if (rangeLength >= 8192) {
        // Inline function 'kotlin.error' call
        var message = 'Header line length limit exceeded';
        throw IllegalStateException().o(toString(message));
      }
      var nameStart = range.f59_1;
      var nameEnd = parseHeaderName(builder, range);
      var headerEnd = range.g59_1;
      parseHeaderValue(builder, range);
      var valueStart = range.f59_1;
      var valueEnd = range.g59_1;
      range.f59_1 = headerEnd;
      headers.j58(nameStart, nameEnd, valueStart, valueEnd);
    }
    var host = headers.k2o('Host');
    if (!(host == null)) {
      validateHostHeader(host);
    }
    return headers;
  } catch ($p) {
    if ($p instanceof Error) {
      var t = $p;
      headers.e2m();
      throw t;
    } else {
      throw $p;
    }
  }
}
function parseHeaderName(text, range) {
  _init_properties_HttpParser_kt__gbdom1();
  var index = range.f59_1;
  var end = range.g59_1;
  while (index < end) {
    var ch = text.b(index);
    if (ch === _Char___init__impl__6a9atx(58) && !(index === range.f59_1)) {
      range.f59_1 = index + 1 | 0;
      return index;
    }
    if (isDelimiter(ch)) {
      parseHeaderNameFailed(text, index, range.f59_1, ch);
    }
    index = index + 1 | 0;
  }
  noColonFound(text, range);
}
function parseHeaderValue(text, range) {
  _init_properties_HttpParser_kt__gbdom1();
  var start = range.f59_1;
  var end = range.g59_1;
  var index = start;
  index = skipSpacesAndHorizontalTabs(text, index, end);
  if (index >= end) {
    range.f59_1 = end;
    return Unit_instance;
  }
  var valueStart = index;
  var valueLastIndex = index;
  while (index < end) {
    var ch = text.b(index);
    if (ch !== _Char___init__impl__6a9atx(9) && ch !== _Char___init__impl__6a9atx(32))
      if (ch === _Char___init__impl__6a9atx(13) || ch === _Char___init__impl__6a9atx(10)) {
        characterIsNotAllowed(text, ch);
      } else
        valueLastIndex = index;
    index = index + 1 | 0;
  }
  range.f59_1 = valueStart;
  range.g59_1 = valueLastIndex + 1 | 0;
}
function validateHostHeader(host) {
  _init_properties_HttpParser_kt__gbdom1();
  if (endsWith(host, ':')) {
    throw ParserException().l59("Host header with ':' should contains port: " + toString(host));
  }
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.text.any' call
    var inductionVariable = 0;
    while (inductionVariable < charSequenceLength(host)) {
      var element = charSequenceGet(host, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      if (get_hostForbiddenSymbols().t2(new (Char())(element))) {
        tmp$ret$0 = true;
        break $l$block;
      }
    }
    tmp$ret$0 = false;
  }
  if (tmp$ret$0) {
    throw ParserException().l59('Host cannot contain any of the following symbols: ' + toString(get_hostForbiddenSymbols()));
  }
}
function isDelimiter(ch) {
  _init_properties_HttpParser_kt__gbdom1();
  return Char__compareTo_impl_ypi4mb(ch, _Char___init__impl__6a9atx(32)) <= 0 || contains('"(),/:;<=>?@[\\]{}', ch);
}
function parseHeaderNameFailed(text, index, start, ch) {
  _init_properties_HttpParser_kt__gbdom1();
  if (ch === _Char___init__impl__6a9atx(58)) {
    throw ParserException().l59('Empty header names are not allowed as per RFC7230.');
  }
  if (index === start) {
    throw ParserException().l59('Multiline headers via line folding is not supported since it is deprecated as per RFC7230.');
  }
  characterIsNotAllowed(text, ch);
}
function noColonFound(text, range) {
  _init_properties_HttpParser_kt__gbdom1();
  var tmp2 = range.f59_1;
  // Inline function 'kotlin.text.substring' call
  var endIndex = range.g59_1;
  var tmp$ret$0 = toString(charSequenceSubSequence(text, tmp2, endIndex));
  throw ParserException().l59('No colon in HTTP header in ' + tmp$ret$0 + ' in builder: \n' + toString(text));
}
function characterIsNotAllowed(text, ch) {
  _init_properties_HttpParser_kt__gbdom1();
  // Inline function 'kotlin.code' call
  var tmp$ret$0 = Char__toInt_impl_vasixd(ch);
  throw ParserException().l59('Character with code ' + (tmp$ret$0 & 255) + ' is not allowed in header names, \n' + toString(text));
}
var ParserExceptionClass;
function ParserException() {
  if (ParserExceptionClass === VOID) {
    class $ extends IllegalStateException() {
      static l59(message) {
        var $this = this.o(message);
        captureStack($this, $this.k59_1);
        return $this;
      }
    }
    initMetadataForClass($, 'ParserException');
    ParserExceptionClass = $;
  }
  return ParserExceptionClass;
}
var properties_initialized_HttpParser_kt_uedryv;
function _init_properties_HttpParser_kt__gbdom1() {
  if (!properties_initialized_HttpParser_kt_uedryv) {
    properties_initialized_HttpParser_kt_uedryv = true;
    hostForbiddenSymbols = setOf([new (Char())(_Char___init__impl__6a9atx(47)), new (Char())(_Char___init__impl__6a9atx(63)), new (Char())(_Char___init__impl__6a9atx(35)), new (Char())(_Char___init__impl__6a9atx(64))]);
    httpLineEndings = LineEndingMode__plus_impl_ttpz2j(Companion_getInstance().l4l_1, Companion_getInstance().k4l_1);
    versions = Companion_instance.m59(listOf(['HTTP/1.0', 'HTTP/1.1']));
  }
}
//region block: exports
export {
  parseHeaders as parseHeaderswkac0gpavig,
};
//endregion

//# sourceMappingURL=HttpParser.mjs.map
